import axios from 'axios';
import { put, takeEvery } from 'redux-saga/effects';

function* fetchEmailSettings() {
    try {
        const emailSettingsResponse = yield axios.get('/api/emailSettings');
        yield put({type: 'SET_EMAIL_SETTINGS', payload: emailSettingsResponse.data[0]});
    }
    catch (error){
        console.log(`COULDN'T GET THE EMAIL SETTINGS ${error}`);
    }
}

function* emailSettingsSaga() {
    yield takeEvery('FETCH_EMAIL_SETTINGS', fetchEmailSettings);
  }

export default emailSettingsSaga;